import '@aws-amplify/ui-react/styles.css';

import { View, Link, Button, useAuthenticator } from '@aws-amplify/ui-react';

export function SignInFooter() {
  const { toForgotPassword } = useAuthenticator();
  return (
    <View textAlign="center">
      <Button
        class='amplify-button amplify-field-group__control amplify-button--link amplify-button--small'
        type='button'
        onClick={toForgotPassword}>
        Reset Password
      </Button>
      <div>
        <p>New Here? <Link href="https://www.hazardwatch.ca/">Visit Hazard Watch</Link></p>
      </div>
    </View>
  );
};